import React  from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material"
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import { errorsFormRegisterState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import HelperTextInput from 'src/shared/components/alerts/HelperTextInput';
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"

const PasswordTemporalField = ({ onKeyEnter }) => {
    const { claveTemporal } = useRecoilValue(valuesFormRegisterState);
    const { claveTemporal: errorsClaveTemporal } = useRecoilValue(errorsFormRegisterState);
    const [showPasswordTemporal, setShowPasswordTemporal] = useState(false)
    const { handleChange } = useSavePatient();

    let propsPasswordTemporal = {};
    if(onKeyEnter) {
        propsPasswordTemporal['onKeyPress'] = (ev) => {
            if (ev.key === "Enter") {
                onKeyEnter();
            }
        }
    }

    const handleClickShowPassword = () => {
        setShowPasswordTemporal(!showPasswordTemporal);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <InputLabelCustom htmlFor="input-password-temporal" text="Clave temporal (*)" />
            <OutlinedInput
                id="input-password-temporal"
                size="small"
                error={errorsClaveTemporal && errorsClaveTemporal.length > 0 ? true : false}
                style={{ width: '100%' }}
                name="claveTemporal"
                type={showPasswordTemporal ? 'text' : 'password'}
                value={claveTemporal || ""}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPasswordTemporal ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                onChange={(ev) => {
                    handleChange(ev);
                }}
                autoFocus
                {...propsPasswordTemporal}
                autoComplete="off"
            />
            {
                errorsClaveTemporal && errorsClaveTemporal.length > 0 ?
                <HelperTextInput messages={errorsClaveTemporal} />
                : null
            }
        </>
    )
}

export default PasswordTemporalField;